<template>
  <app-layout>
    <div v-loading.fullscreen="loading || loadingBuild">
      <!-- <app-stepper :scaffold="scaffold" :current="0" /> -->

      <div class="max-w-screen-xl mx-auto px-5">
        <div v-if="!loading">
          <app-builder-actions
            class="mt-5 mb-3"
          ></app-builder-actions>

          <el-alert
            v-if="error"
            :title="error.header"
            :description="error.message"
            type="error"
            show-icon
            @close="clearError"
            class="mb-3"
          ></el-alert>

          <app-property-form
            v-if="propertyEnabled"
          ></app-property-form>
          <app-entity-list
            v-if="entityEnabled"
          ></app-entity-list>
          <app-relationship-list
            v-if="relationshipEnabled"
          ></app-relationship-list>
          <app-builder-debugger
            v-if="debugging"
            :data="data"
          ></app-builder-debugger>

          <div class="my-4">
            <app-builder-download-data-button
              v-if="simulating"
            ></app-builder-download-data-button>
            <app-builder-generate-button
              v-if="!simulating"
            ></app-builder-generate-button>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import config from '../config';

export default {
  name: 'app-builder',

  props: {
    scaffoldId: {
      type: String,
      required: true,
    },
    reload: {
      type: Boolean,
      required: false,
    },
  },

  created() {
    const { dispatch } = this.$store;
    const version = this.$route.query.version;
    const frontend = this.$route.query.frontend;

    return dispatch('builder/setup', {
      scaffoldId: this.scaffoldId,
      version,
      reload: !!this.reload,
      frontend,
    })
      .catch(() => {
        window.location.href = config.CLIENT_WEB_URL;
      })
      .finally(() => {
        if (version) {
          this.$router.replace({ query: {} });
        }
      });
  },

  computed: {
    ...mapGetters({
      scaffold: 'scaffold/current',
      loading: 'builder/loading',
      loadingBuild: 'builder/loadingBuild',
      entityEnabled: 'builder/entity/enabled',
      relationshipEnabled: 'builder/relationship/enabled',
      data: 'builder/data',
      debugging: 'builder/debugging',
      simulating: 'builder/simulating',
      originalProject: 'builder/originalProject',
      error: 'builder/error',
    }),

    propertyEnabled() {
      return this.$store.getters[
        'builder/property/enabled'
      ]();
    },
  },

  methods: {
    ...mapActions({
      clearError: 'builder/clearError',
    }),

    async goToOriginalProject() {
      try {
        await this.$confirm(
          'Are you sure? Current project will be discarded.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      this.$router.push({
        name: 'project-preview',
        params: { projectId: this.originalProject.id },
      });
    },
  },
};
</script>

<style></style>
